import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.28em] ${light ? "text-champagne-light" : "text-champagne-dark"}`}>
    <span className={`h-px w-10 ${light ? "bg-champagne-light" : "bg-champagne-dark"}`} />
    {children}
  </p>
);

export const SectionTitle = ({ title, accent, light = false }) => (
  <h2 className={`mt-5 font-display text-3xl font-extrabold uppercase leading-[1] tracking-tight sm:text-4xl lg:text-5xl ${light ? "text-pearl" : "text-ink"}`}>
    {title} <span className="font-serif text-[1.05em] font-normal normal-case italic tracking-normal text-champagne-dark">{accent}</span>
  </h2>
);
